module.exports = __webpack_public_path__ + "fonts/fontawesome/fa-regular-400.ttf";